<template>
    <div class="row d-flex v-spacing-child-prj">
        <!--        todo: auch wenn adresse gewählt -> immer noch editierbar-->
        <div class="column d-flex flex-column@until-medium">
          <div v-html="versandaufteilungService.getConcatenatedAddress(address, '<br />')" />
            <div class="ml-auto@medium flex-child-fix d-flex flex-wrap justify-content-between@until-medium v-spacing-prj@until-medium gap-4 ml-2 align-items-center">
                <a v-if="showAddressBook" class="btn btn--dark w-75@until-medium mr-prj mr-2@large" @click="openAddressModal">{{'versandaufteilungAddressbuch'|translate}}</a>
                <div class="d-flex flex-row gap-2">
                  <a class="btn btn--link p-0" v-if="address.addressinfoid <= 0"
                     @click="openTextAddressModal" :title="'versandaufteilungAnpassen'|translate">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon svg-icon--large">
                      <g clip-path="url(#clip0_32_2115)">
                        <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#3A3A39"/>
                        <path d="M7.54167 16.4583H8.53333L14.6427 10.3489L13.651 9.35725L7.54167 15.4666V16.4583ZM17.6708 9.32183L14.6604 6.34683L15.6521 5.35517C15.9236 5.08364 16.2572 4.94788 16.653 4.94788C17.0482 4.94788 17.3816 5.08364 17.6531 5.35517L18.6448 6.34683C18.9163 6.61836 19.058 6.94608 19.0698 7.33C19.0816 7.71345 18.9517 8.04093 18.6802 8.31246L17.6708 9.32183ZM6.83333 17.875C6.63264 17.875 6.46453 17.807 6.329 17.671C6.193 17.5354 6.125 17.3673 6.125 17.1666V15.1656C6.125 15.0711 6.14271 14.9798 6.17813 14.8915C6.21354 14.8027 6.26667 14.7229 6.3375 14.652L13.6333 7.35621L16.6438 10.3666L9.34792 17.6625C9.27708 17.7333 9.19751 17.7864 9.10921 17.8218C9.02043 17.8573 8.92882 17.875 8.83437 17.875H6.83333ZM14.1469 9.85308L13.651 9.35725L14.6427 10.3489L14.1469 9.85308Z" fill="#0095D2"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_32_2115">
                          <rect width="24" height="24" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                  <a class="btn btn--link p-0" v-if="canRemoveAddress"
                     @click="versandaufteilungService.removeAddress(index)" :title="'txtDeleteAddress'|translate">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" class="svg-icon svg-icon--large"><circle cx="18" cy="18" r="18" fill="#3a3a39"/><path d="M24.92 23.33L19.59 18l5.32-5.32c.44-.44.44-1.15 0-1.59-.44-.44-1.15-.44-1.59 0L18 16.41l-5.32-5.32c-.44-.44-1.15-.44-1.59 0-.44.44-.44 1.15 0 1.59L16.41 18l-5.32 5.32c-.44.44-.44 1.15 0 1.59.44.44 1.15.44 1.59 0L18 19.59l5.33 5.33c.44.44 1.15.44 1.59 0s.44-1.15 0-1.59z" fill="#fff"/></svg>
                  </a>
                </div>
            </div>
            <hr class="hide-for-medium mb-prj mt-prj2" />
        </div>
    </div>
</template>

<script>
    import MysignGlobals from "mixins/mysignGlobals";
    import FlyerlineModal from "fragments/FlyerlineModal.vue";
    import AddressBook from "components/versandaufteilung/AddressBook.vue";
    import TextAddress from "components/versandaufteilung/TextAddress.vue";

    export default {
        components: {TextAddress, FlyerlineModal, AddressBook},
        props: ['address', 'canRemoveAddress', 'addressService', 'index', 'showAddressBook'],
        mixins: {MysignGlobals},
        inject: ['versandaufteilungService'],
        methods: {
            openAddressModal() {
                this.addressService.updateAddressBookAddress(this.index);
            },
            openTextAddressModal() {
                this.addressService.updateTextAddress(this.index);
            },
            selectAddress(addressData) {
                this.$emit('updateAddress', addressData);
                this.$modal.hide('addressBookModal')
            },
            selectAddressText(addressData) {
                this.$emit('updateAddress', addressData);
                this.$modal.hide('textAddressModal')
            },
        }
    }
</script>